import React, { useState, useEffect } from "react";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step6 from "./step6";
import FinalStep from "./FinalStep";
import { useSelector, useDispatch } from "react-redux";
import {
  getAgentTraits,
  getAudioLibrary,
} from "../../../store/appearance/actions";
import FadeLoader from "react-spinners/FadeLoader";

const CreateAvtar = () => {
  const { loading, AgentTraits } = useSelector((state) => state.Appearance);
  const dispatch = useDispatch();
  const fetchData = () => {
    const callBack = (err, responce) => {
      if (err) {
        // toast.error(err.message);
      } else {
        console.log(responce, "teststs");
      }
    };
    dispatch(
      getAgentTraits({
        callBack: callBack,
      })
    );
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    // Step 1
    gender: "",
    imageUrl: "",
    voiceUrl: "",
    voiceId: "",
    stitch: true,

    // Step 2
    fullname: "",
    dob: "",
    lifeStory: "",
    personality: [],
    education: "",
    profession: "",

    // Step 3
    hobbies: [],
    background: "",

    // Step 4
    importantMemories: [
      {
        "Year/age": "",
        "Memory/event": "",
        Description: "",
      },
    ],
  });

  console.log(formData, "formmmchekckk");
  const [errors, setErrors] = useState({});
  const handleInputChange = (name, value) => {
    console.log(name, value, "datacheckkkk");
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleCheckboxChange = (arrayName, value) => {
    setFormData((prev) => {
      const currentArray = prev[arrayName];
      const isChecked = currentArray.includes(value);

      return {
        ...prev,
        [arrayName]: isChecked
          ? currentArray.filter((item) => item !== value)
          : [...currentArray, value],
      };
    });

    // Clear error when user makes a selection
    if (errors[arrayName]) {
      setErrors((prev) => ({
        ...prev,
        [arrayName]: "",
      }));
    }
  };

  const handleObjectArrayChange = (arrayName, index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [arrayName]: prev[arrayName].map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      ),
    }));

    // Clear error when user starts typing
    // const errorKey = `${arrayName.slice(0, -1)}_${index}_${field}`;
    const errorKey = `${arrayName}_${index}_${field}`;
    if (errors[errorKey]) {
      setErrors((prev) => ({
        ...prev,
        [errorKey]: "",
      }));
    }
  };

  const addToArray = (arrayName, defaultValue) => {
    setFormData((prev) => ({
      ...prev,
      [arrayName]: [...prev[arrayName], defaultValue],
    }));
  };

  const removeFromArray = (arrayName, index) => {
    setFormData((prev) => ({
      ...prev,
      [arrayName]: prev[arrayName].filter((_, i) => i !== index),
    }));
  };

  const fetchAudioLibrary = () => {
    const callBack = (err, responce) => {
      if (err) {
        // toast.error(err.message);
      } else {
        console.log(responce, "teststs");
      }
    };
    dispatch(
      getAudioLibrary({
        data: formData.gender,
        callBack: callBack,
      })
    );
  };

  useEffect(() => {
    if (formData.gender) {
      fetchAudioLibrary();
    }
  }, [formData.gender]);

  const handleRadioChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user selects an option
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  return (
    <>
      {/* {loading && (
        <div
          className="main-loader2 d-flex align-items-center justify-content-center"
          style={{ height: 300 }}
        >
          <FadeLoader size={1000} />
        </div>
      )} */}
      {/* {!loading && ( */}
      <section className="py-4 relative">
        <div className="px-3 container">
          <div className="grid  gap-10  grid-cols-12">
            <div className="col-span-12">
              <div className=" z-[99] relative dark:bg-[#000]/50 bg-[#F5F5F5] rounded-[12px] h-[calc(100vh-120px)] overflow-auto scrollbar-none">
                {step === 1 ? (
                  <Step1
                    step={step}
                    setStep={setStep}
                    errors={errors}
                    setErrors={setErrors}
                    formData={formData}
                    AgentTraits={AgentTraits}
                    handleInputChange={handleInputChange}
                  />
                ) : step === 2 ? (
                  <>
                    <Step2
                      step={step}
                      setStep={setStep}
                      errors={errors}
                      setErrors={setErrors}
                      formData={formData}
                      AgentTraits={AgentTraits}
                      handleInputChange={handleInputChange}
                      handleCheckboxChange={handleCheckboxChange}
                    />
                  </>
                ) : step == 3 ? (
                  <>
                    <Step3
                      step={step}
                      setStep={setStep}
                      errors={errors}
                      setErrors={setErrors}
                      formData={formData}
                      AgentTraits={AgentTraits}
                      handleCheckboxChange={handleCheckboxChange}
                      handleInputChange={handleInputChange}
                    />
                  </>
                ) : step == 4 ? (
                  <>
                    <Step4
                      step={step}
                      setStep={setStep}
                      errors={errors}
                      setErrors={setErrors}
                      formData={formData}
                      handleObjectArrayChange={handleObjectArrayChange}
                      addToArray={addToArray}
                      removeFromArray={removeFromArray}
                    />
                  </>
                ) : step == 5 ? (
                  <>
                    <FinalStep
                      step={step}
                      setStep={setStep}
                      errors={errors}
                      formData={formData}
                      AgentTraits={AgentTraits}
                    />
                  </>
                ) : step == 6 ? (
                  <>
                    <Step6
                      step={step}
                      setStep={setStep}
                      errors={errors}
                      setErrors={setErrors}
                      formData={formData}
                      AgentTraits={AgentTraits}
                      handleRadioChange={handleRadioChange}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* )} */}
    </>
  );
};

export default CreateAvtar;
